import{jsx as u}from"react/jsx-runtime";import o,{css as t}from"styled-components";const e=t`
  font-family: ${({theme:n})=>n.typography.fontAlternativeFamily};
  font-weight: ${({theme:n})=>n.typography.fontAlternativeBoldWeight};
`,l=t`
  font-size: 1.25rem;
  line-height: 1.25rem;
`,a=t`
  ${e}
  ${l}
`,y=o.span`
  ${a}
`,r=t`
  font-size: 1rem;
  line-height: 1rem;
`,i=t`
  ${e}
  ${r}
`,g=o.span`
  ${i}
`,m=t`
  font-size: 0.75rem;
  line-height: 0.75rem;
`,s=t`
  ${e}
  ${m}
`,h=o.span`
  ${s}
`,B=()=>u("div",{});export{e as BasicButtonFontStyle,g as Button,y as ButtonLarge,l as ButtonLargeFontStyle,a as ButtonLargeTextStyle,r as ButtonRegularFontStyle,i as ButtonRegularTextStyle,h as ButtonSmall,m as ButtonSmallFontStyle,s as ButtonSmallTextStyle,B as default};
